module.exports = __webpack_public_path__ + "img/gift4-01-c04-y1.3e60de17.png";